<template>
  <div id="user-rule-detail-modal" class="modal" v-if="modalShown">
    <div class="modal-main">
      <div class="title-area">
        <h2>利用規約</h2>
      </div>
      <div class="rule_parts" >
        <dd-user-rule-detail
        />
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="closeModal">閉じる</button>
      </div>
    </div>
  </div>
</template>
<script>
import UserRuleDetail from './UserRuleDetail'

export default {
  name: 'UserRuleDetailModal',
  components: {
    'dd-user-rule-detail': UserRuleDetail
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false
    }
  },
  methods: {
    showModal: function () {
      this.modalShown = true
    },
    closeModal: function () {
      this.modalShown = false
    }
  }
}
</script>
<style lang="scss" scoped>
#user-rule-detail-modal {
  color: #000;
}
.modal-main {
  max-height: 100%;
  min-width: 609px;
}
.rule_parts{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/UserRuleDetailModal.vue